import { useState } from "react";

export default function AutomationCard() {
  const [paused, setPaused] = useState(false);

  return (
    <div className="bg-[#0B1120] rounded-2xl p-6 flex flex-col sm:flex-row gap-6 items-start sm:items-center">
      <div className="w-12 h-12 flex items-center justify-center bg-[#25D366]/20 rounded-xl flex-shrink-0">
        <i className="ri-robot-line text-[#25D366] text-2xl"></i>
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-3 mb-1 flex-wrap">
          <h3 className="text-white font-bold text-base">Aktif Hatırlatma Sistemi</h3>
          <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap
            ${paused ? "bg-amber-500/20 text-amber-400" : "bg-[#25D366]/20 text-[#25D366]"}
          `}>
            <span className={`w-1.5 h-1.5 rounded-full ${paused ? "bg-amber-400" : "bg-[#25D366] animate-pulse"}`}></span>
            {paused ? "Durduruldu" : "Çalışıyor"}
          </span>
        </div>
        <p className="text-white/50 text-sm">
          Sistem her <strong className="text-white/80">6 dakikada bir</strong> sıradaki mesajı gönderecek şekilde hazırlanmıştır.
        </p>
        <div className="flex gap-4 mt-3 flex-wrap">
          <div className="text-xs text-white/40">
            <span className="text-white/70 font-medium">Son kontrol:</span> 14:32
          </div>
          <div className="text-xs text-white/40">
            <span className="text-white/70 font-medium">Sonraki:</span> ~6 dk içinde
          </div>
          <div className="text-xs text-white/40">
            <span className="text-white/70 font-medium">Bugün gönderilen:</span> 6 mesaj
          </div>
        </div>
      </div>
      <button
        onClick={() => setPaused(!paused)}
        className={`px-5 py-2.5 rounded-xl text-sm font-semibold cursor-pointer whitespace-nowrap transition-all flex-shrink-0
          ${paused
            ? "bg-[#25D366] text-white hover:bg-[#1da851]"
            : "bg-white/10 text-white/80 hover:bg-white/20"
          }
        `}
      >
        {paused ? "Sistemi Başlat" : "Sistemi Durdur"}
      </button>
    </div>
  );
}